import BaseFormController from "../../../../../validation/BaseFormController";
import {FormField, OptionalFormField, RequiredFormField} from "../../../../../validation/FormField";
import {none, option} from "ts-option";
import FormValidators from "../../../../../validation/FormValidators";
import FormValidation from "../../../../../validation/FormValidation";
import HelpRequest from "../../../../../model/help/HelpRequest";
import User from "../../../../../model/user/User";

const uuidv4 = require("uuid/v4");
const { detect } = require('detect-browser');
const browser = detect();
/**
 * Help contact form data.
 */
export default class HelpContactForm extends BaseFormController<HelpContactForm> {
	constructor(formId: string,
		public readonly name: RequiredFormField<string>,
		public readonly organization: RequiredFormField<string>,
		public readonly email: RequiredFormField<string>,
		public readonly contactNumber: OptionalFormField<string>,
		public readonly requestText: RequiredFormField<string>) {
		super(name, formId);
	}

	static createContactForm({
		name = none,
		organization = none,
		email = none,
		contactNumber = none,
		requestText = none
	}) {
		return new HelpContactForm(
			uuidv4(),
			RequiredFormField.create<string>(name, "Name is required"),
			RequiredFormField.create<string>(organization, "Organization name is required"),
			RequiredFormField.create<string>(email, "Email is required", [FormValidators.email]),
			OptionalFormField.create<string>(contactNumber),
			RequiredFormField.create<string>(requestText, "Message is required")
		)
	}

	/**
	 * Creates form from user model.
	 * @param {User} user User Detail.
	 * @returns {HelpContactForm} Form for the component.
	 */
	static createFromUser(user: User) {
		return HelpContactForm.createContactForm({
			name: option(user.getDisplayName()),
			email: option(user.data.username),
			organization: option(user.data.organisationName),
			contactNumber: user.data.mobileNumber.map(n => n.nationalPhoneNumber)
		});
	}

	validate(): HelpContactForm {
		return FormValidation.validateForm<HelpContactForm>(this, (form, config) => form.copy(config));
	}

	onValid(callback: (data: HelpRequest) => void): void {
		const browserVersion = browser && browser.name.concat(" ", browser.version);
		FormValidation.validateFields(
			[this.name, this.organization, this.email, this.requestText],
			() => new HelpRequest(this.name.getValue(), this.organization.getValue(), this.email.getValue(),
				this.contactNumber.getOptionalValue(), this.requestText.getValue(), browserVersion, process.env.UI_VERSION)
		).onSuccess(callback)
	}

	copy({
		name = this.name,
		organization = this.organization,
		email = this.email,
		contactNumber = this.contactNumber,
		requestText = this.requestText
	}): HelpContactForm {
		return new HelpContactForm(this.formId, name, organization, email, contactNumber, requestText)
	}

	fields(): FormField<any> [] {
		return [];
	}
}